module.exports = __webpack_public_path__ + "img/logo-default.84f34a35.png";